<template>
  <span>     
    <span v-if="showmessagebar" @click="showmessagebar=false" class="w3-bottom w3-bar w3-theme-l4 bottommenubarmessages">
          <span class="w3-button w3-large w3-display-topright">X</span>
          <span class="w3-button w3-large w3-display-topleft">Logs</span>
          <br> 
          <ul class="w3-ul w3-small">
            <li :key="index" v-for="(item,index) in last10messages">{{index+1}}.             
              <font :color="[item.type==='error'? 'red' : item.type==='warning'? 'orange' : 'green' ]">{{item.message}}</font>
            </li> 
          </ul>
      </span>

      <span class="w3-bottom w3-bar w3-theme-l2 bottommenubar">
        
        <i @click="showmessagebar=!showmessagebar;setBannerMessage(null)" class="fa fa-exclamation-circle w3-left" v-if="last10messages"> ({{last10messages.length}})</i> 
        
        <span v-if="!fcmToken || fcmToken==='errornotoken'" class="w3-display-middle"  @click="setNotifications()">Notices?</span>

        <span v-if="!location" class="w3-right"  @click="setCurrentLocation()">Set Location <i class="fa fa-map-marker"></i></span>        
        <i class="fa fa-map-marker w3-right w3-green" v-if="location"></i>

      </span>
      
      <span @click="setBannerMessage(null)" v-if="bannermessage" class="w3-bottom w3-bar w3-theme-l2 bannermessage"
            :class="[bannermessage.type==='error'? 'w3-red' : bannermessage.type==='warning'? 'w3-orange' : 'w3-green' ]">          
            <span  class="w3-button w3-large w3-right" :class="[bannermessage.type==='error'? 'w3-red' : bannermessage.type==='warning'? 'w3-orange' : 'w3-green' ]">×</span>          
            <p>{{bannermessage.message}}</p>
      </span> 
  </span> 
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
export default {    
  
  data() {
      return {          
        showmessagebar:false
      }
    },
  methods: {
    ...mapActions(["setBannerMessage","setNotifications","setCurrentLocation"]),
    click(action){
       this.$emit("click", {
          action: action
      });      
    }
  },      
  computed: {      
    ...mapGetters(["fcmToken","last10messages","location","bannermessage"])
  }
};
</script>
 
<style>
  
   .bottommenubarmessages{
     height:400px;
     padding:5px;
     padding: 10px;    
     padding: 10px;    
     margin-bottom: 40px;
     z-index: 2;
   }

      .bottommenubar{
     height:40px;
     padding-top:5px;
     padding-left: 20px;    
     padding-right: 10px;    
   }

      .bannermessage{
     padding-left: 10px;   
     margin-bottom: 40px; 
     z-index: 2;
   }

</style>



// WEBPACK FOOTER //
// src/components/app/MessageCentreLayout.vue